module.exports = __webpack_public_path__ + "img/vuepokedek.f6c21ed4.jpg";